import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_NAV_ITEM } from '../../../../store/js/modules/video-hub/nav/actions';
import { navSelector } from '../../../../store/js/modules/video-hub/nav/selectors/nav-selector';
import { Loader } from '../../../../../../common/react/components/Loader';

import { NavItem } from './NavItem';

export const RoundListNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const roundsList = useSelector(
        (state) => state.rounds[`season_${nav.season.id}`]?.list
    );

    if (!roundsList) {
        return (
            <ul className="video-hub__round-list">
                <Loader />
            </ul>
        );
    }

    const onNavItemClick = (event, label) => {
        dispatch(
            UPDATE_NAV_ITEM.request({
                navItem: 'round',
                value: label
            })
        );
    };

    return (
        <ul className="video-hub__round-list">
            {roundsList.length
                ? roundsList.map((round, index) => (
                      <NavItem
                          key={index}
                          label={round.roundNumber}
                          onClick={onNavItemClick}
                      />
                  ))
                : ''}
        </ul>
    );
};
